import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

enum Selectors {
	Collapse = '.js-m-collapse__collapse',
	Button = '.js-m-collapse__button',
	ButtonText = '.js-a-button__text',
}

// The @Component decorator will connect the class with `data-g-name="Collapse"` elements.
@Component('Collapse')
export class Collapse extends GondelJqueryComponent {
	public start() {
		const $button = this.$ctx.find(Selectors.Button);
		const $buttonText = $button.find(Selectors.ButtonText);
		const $collapsedItem = this.$ctx.find(Selectors.Collapse);

		// set initial button text
		$buttonText.text($button.data('i18n-show'));

		// update button text on open / close
		$collapsedItem.on('shown.bs.collapse', (ev: JQuery.Event) => {
			$buttonText.text($button.data('i18n-hide'));
		});

		$collapsedItem.on('hidden.bs.collapse', (ev: JQuery.Event) => {
			$buttonText.text($button.data('i18n-show'));
		});
	}
}
